<template>
  <BaseSidebar @open="$emit('open')" @close="$emit('close')">
    <template v-slot:top-bar="{ showContent, activeContent }">
      <ButtonBarItem
          label="Ficha paciente"
          variant="primary"
          @click="showContent(0)"
          :is-active="activeContent === 0"
      ><IconMedicalFile width="100%" height="100%"/></ButtonBarItem>
    </template>
    <template v-slot:contents>
      <NutritionalPatientInfo data-content-ref="0" :patient-data="patientData" :poll-data="pollData"/>
    </template>
  </BaseSidebar>
</template>

<script>
  import BaseSidebar from './base/BaseSidebar'
  import ButtonBarItem from './base/ButtonBarItem'
  import NutritionalPatientInfo from './content/NutritionalPatientInfo'
  import IconMedicalFile from '../icon/IconMedicalFile'

  export default {
    name: 'DietSettingsSidebar',
    components: {
      IconMedicalFile,
      NutritionalPatientInfo,
      BaseSidebar,
      ButtonBarItem
    },
    props: {
      unsavedChanges: {
        type: Boolean,
        default: false,
      },
      isSaving: {
        type: Boolean,
        default: false,
      },
      isExporting: {
        type: Boolean,
        default: false,
      },
      patientData: {
        type: Object,
        default: function(){
          return {};
        },
      },
      pollData: {
        type: Object,
        default: function(){
          return {};
        },
      }
    },
    computed: {
      isProcessing () { return this.isSaving || this.isExporting; }
    },
    methods: {
      getDietFile () {
        this.$emit("get-diet-file");
      },
      saveDiet () {
        this.$emit("save-diet");
      },
      addMeal () {
        this.$emit("add-meal");
      },
    },
  }
</script>

<style scoped lang="scss">
  .btnbar-separator {
    background-color: $gray-300;
    height: 1px;
    margin: $spacer auto;
    width: $btnbar-btn-size*0.8;
  }
</style>